/* Tlačítko košíku v hlavičce: drží aria-label ovládacího prvku v souladu s počtem.
   Proč: motiv po přidání nebo změně košíku přepisuje jen innerHTML #cart-icon-bubble
   (Section Rendering API z product-form.js, cart.js, gift-threshold.js, cart:refresh...).
   Tlačítko i počet se tím překreslí samy ze snippetu, ale aria-label na rodičovském
   <summary> (boční košík) nebo <a> (stránka /cart) zůstane z prvního vykreslení.
   Text bere z data-label tlačítka, které skládá Liquid, takže tu nejsou žádné texty ani
   skloňování a CZ/SK řeší jediné místo (snippets/nebe-cart-btn.liquid). */
(() => {
  let observed = null;
  let observer = null;

  function sync() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    // V bočním košíku je ovládací prvek summary nad bublinou, jinde je bublina sama odkazem.
    const control = bubble.closest('[data-nebe-cbtn-empty]');
    if (!control) return;
    const btn = bubble.querySelector('[data-nebe-cbtn]');
    const label = btn ? btn.getAttribute('data-label') : control.getAttribute('data-nebe-cbtn-empty');
    if (label && control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
  }

  function watch() {
    const bubble = document.getElementById('cart-icon-bubble');
    // Editor motivu umí hlavičku vyměnit celou; pak je to nový uzel a pozorovatel se přesune.
    if (bubble === observed) return sync();
    if (observer) observer.disconnect();
    observed = bubble;
    if (bubble) {
      observer = observer || new MutationObserver(sync);
      observer.observe(bubble, { childList: true });
    }
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();
